// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'c37c74a7a462bca4fc11be66124c56ac43b3b443';
export const BUILD_NUMBER = '187';
export const BUILD_TIMESTAMP = '2026-07-03T02:41:21.945Z';
